import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { ServiceCard } from './ServiceCard';
import { MarketTabs } from './MarketTabs';
import { useLanguage } from '../contexts/LanguageContext';
import { useMarketTab } from '../hooks/useMarketTab';
import { paintingServices } from '../data/services';
import { ui } from '../data/ui';
export function ServiceCards() {
  const {
    t
  } = useLanguage();
  const [market, setMarket] = useMarketTab();
  const s = ui.services;
  const items = paintingServices.filter(x => x.market === market);
  const featureFirst = items.length % 2 === 1;
  return <section id="services" className="relative bg-white py-20 md:py-24" aria-labelledby="services-title" data-id="element-323" data-mp="henrwn3ttxto">
      <span id="commercial-painting" className="absolute top-0" aria-hidden="true" data-id="element-324" data-mp="ddltg8hqhpsr" />
      <span id="residential-painting" className="absolute top-0" aria-hidden="true" data-id="element-325" data-mp="r8wk19oy3orb" />
      <div className="container-page" data-id="element-326" data-mp="mdqy4avjma38">
        <SectionHeading id="services-title" title={t(s.title)} subtitle={t(s.subtitle)} data-id="element-327" data-mp="247yi64ujh1sz" />

        <div className="mt-10 flex justify-center" data-id="element-328" data-mp="296rzk8cy5cyf">
          <MarketTabs value={market} onChange={setMarket} idPrefix="services" label={t(s.tabsLabel)} labels={{
          commercial: t(s.tabCommercial),
          residential: t(s.tabResidential)
        }} data-id="element-329" data-mp="297kzapdhn272" />
        </div>

        <div id="services-panel" role="tabpanel" aria-labelledby={`services-tab-${market}`} className="mt-10" data-id="element-330" data-mp="2n72rlepzsxl6">
          <AnimatePresence mode="wait" initial={false} data-id="element-331" data-mp="2s4vu9xs379gp">
            <motion.div key={market} initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -8
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-332" data-mp="2s3b1odpc20lh">
              <div className="mb-8 flex flex-col gap-3 border-b border-line pb-6 md:flex-row md:items-center md:justify-between" data-id="element-333" data-mp="35yn6jdx7d7g4">
                <span className="inline-flex w-fit items-center rounded-md bg-leaf-wash px-3 py-1.5 text-sm font-bold text-leaf-deep" data-id="element-334" data-mp="3atssuduioo4q">
                  {market === 'commercial' ? t(s.forCommercial) : t(s.forHome)}
                </span>
                <p className="max-w-2xl text-body md:text-right" data-id="element-335" data-mp="1kjyuz6w76fyr">{market === 'commercial' ? t(s.commercialIntro) : t(s.residentialIntro)}</p>
              </div>
              <div className="grid gap-8 lg:grid-cols-2" data-id="element-336" data-mp="1fr5vaxfl5xtj">
                {items.map((item, i) => <ServiceCard key={item.id} service={item} featured={featureFirst && i === 0} data-id="element-337" data-mp="1piscrbiiot4q" data-mpi={i} />)}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}